module.exports = __webpack_public_path__ + "img/sec1_button.cf35d34c.jpg";